import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { BrokerDescriptionModalContent } from './parts/BrokerDescriptionModalContent';
import { BrokerDescriptionModalFooter } from './parts/BrokerDescriptionModalFooter';
import { jsx as _jsx } from "react/jsx-runtime";
export var BrokerDescriptionModal = function BrokerDescriptionModal(_ref) {
  var isOpen = _ref.isOpen,
    isSelfEmployedCheckboxVisible = _ref.isSelfEmployedCheckboxVisible,
    landingUrl = _ref.landingUrl,
    onClose = _ref.onClose,
    onNext = _ref.onNext,
    onRewardInstructionLinkClick = _ref.onRewardInstructionLinkClick,
    personalDataAgreementLink = _ref.personalDataAgreementLink;
  return /*#__PURE__*/_jsx(ModalWindow, {
    content: /*#__PURE__*/_jsx(BrokerDescriptionModalContent, {
      isSelfEmployedInfoVisible: isSelfEmployedCheckboxVisible,
      landingUrl: landingUrl,
      onRewardInstructionLinkClick: onRewardInstructionLinkClick
    }),
    escape: true,
    fixed: false,
    footer: /*#__PURE__*/_jsx(BrokerDescriptionModalFooter, {
      isSelfEmployedCheckboxVisible: isSelfEmployedCheckboxVisible,
      onClose: onClose,
      onNext: onNext,
      personalDataAgreementLink: personalDataAgreementLink
    }),
    onClose: onClose,
    open: isOpen,
    outside: true,
    print: true,
    size: "M",
    width: 928
  });
};